<!-- @format -->
<script lang="ts" context="module">
  export type CampaignConfig = {
    filter_by_category: string;
    filter_by_day: string;
    filter_by_store: string;
    filter_by_search: string;
    filter_by_wishlist: boolean;
    campaign_id: string;
  };
</script>

<script lang="ts">
  import CampaignOffer from "./CampaignOffer.svelte";
  import Filters from "./filters/Filters.svelte";
  import {
    campaign_id,
    filter_by_category,
    filter_by_day,
    filter_by_search,
    filter_by_store,
    filter_by_wishlist,
  } from "./filters/store";

  import { filterOffers } from "./utils";
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";

  let _class = "";
  export { _class as class };
  export let request_store_key: StoresKey;
  export let ilmo: OrangeAdsAPIResponse;
  export let campaignConfig: CampaignConfig;

  const { T } = getStoresContext(request_store_key);

  filter_by_category.set(campaignConfig.filter_by_category);
  filter_by_day.set(campaignConfig.filter_by_day);
  filter_by_store.set(campaignConfig.filter_by_store);
  filter_by_search.set(campaignConfig.filter_by_search);
  filter_by_wishlist.set(false);
  campaign_id.set(campaignConfig.campaign_id);

  let page = 1;
  let size = 18;
  let ads_shown: OrangeAds[] = [];
  let infinite_id = +new Date();
  let ads_filter: OrangeAds[] = [];

  $: {
    if (
      $filter_by_store ||
      $filter_by_category ||
      $filter_by_day ||
      $filter_by_search
    ) {
      ads_filter = filterOffers(
        ilmo,
        $filter_by_category,
        $filter_by_day,
        $filter_by_store,
        $filter_by_search,
      );
    } else {
      ads_filter = ilmo.ad_list;
    }

    page = 1;
    infinite_id += 1;
    ads_shown = ads_filter.slice(0, size);
  }

  function infiniteHandler() {
    page++;
    ads_shown = ads_filter.slice(0, size * page);
  }
</script>

<div class={_class}>
  <div class="container-fluid container-fluid-max-xl">
    <div class="row pb-4 pt-5">
      <Filters {request_store_key} offers={ilmo.ad_list} />
    </div>
    <div class="row">
      {#if ads_shown && ads_shown.length}
        {#each ads_shown as offer (offer.id)}
          <CampaignOffer item={offer} t={$T} />
        {/each}
      {/if}
    </div>
    {#if ads_shown.length < ads_filter.length}
      <div class="row">
        <div class="col-lg-4 col-12" />
        <div class="col-lg-4 col-12">
          <button
            on:click={infiniteHandler}
            type="button"
            class="show-more purple-outline-button mx-auto mb-5 mt-4 w-100 d-block">
            {$T`show-more`}
          </button>
        </div>
        <div class="col-lg-4 col-12" />
      </div>
    {/if}
  </div>
</div>